module.exports = __webpack_public_path__ + "_assets/img/receipt.251aa546.svg";